import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RushMedia } from './components/RushMedia';
import { AppProps } from './types';
import reportWebVitals from './reportWebVitals';

// Default props for development
const defaultProps: AppProps = {
  pwsHost: 'services.premierenetworks.com',
  showSlug: 'rush',
  pageSlug: 'videos',
  isAuthenticated: 1,
  // You can uncomment these for testing specific scenarios:
  // groupSlug: 'live',
  // episodeSlug: 'some-episode'
};

// WordPress Integration
const rushMediaElement = document.getElementById('rush-media-app');
const rootElement = document.getElementById('root');

if (rushMediaElement) {
  // WordPress environment - get props from data attribute
  const propsData = rushMediaElement.getAttribute('data-props') || '{}';
  let props: AppProps;

  try {
    props = JSON.parse(propsData);
  } catch (error) {
    console.error('Failed to parse Rush Media props:', error);
    props = defaultProps;
  }

  const root = ReactDOM.createRoot(rushMediaElement);
  root.render(
    <React.StrictMode>
      <RushMedia {...props} />
    </React.StrictMode>
  );
} else if (rootElement) {
  // Development environment - use default props
  console.log('🚀 Running in development mode with default props:', defaultProps);

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <div>
        {/* <h1 style={{ color: '#fff', marginBottom: '20px' }}>Rush Media Player - Development Mode</h1> */}
        <RushMedia {...defaultProps} />
      </div>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
